import React, { useState, useMemo } from "react";
import { useCompare } from "../CompareContext";
import { useNavigate } from "react-router-dom";
import "./SelectOtherProducts.css";
import products from "../hair_products.json";
import { getProductImage } from "../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const SelectOtherProducts = () => {
    const navigate = useNavigate();
    const { compareList, addToCompare, removeFromCompare } = useCompare();
    const [searchQuery, setSearchQuery] = useState("");

    const allProducts = useMemo(() => Object.values(products).flat(), [products]);

    const filteredProducts = useMemo(() => {
        const query = searchQuery.trim().toLowerCase();
        if (!query) return [];

        const firstProductCategory = compareList.length > 0
            ? Object.keys(products).find((key) =>
                products[key].some((p) => p.barcode === compareList[0].barcode)
            )
            : null;
        let matchingProducts = allProducts.filter((item) => {
            const barcode = item.barcode?.toLowerCase() || "";
            const brand = item.brand?.toLowerCase() || "";
            const name = item.name?.toLowerCase() || "";

            return (
                !compareList.some((cp) => cp.barcode === item.barcode) &&
                (barcode.includes(query) || brand.includes(query) || name.includes(query))
            );
        });
        if (firstProductCategory) {
            const categoryMatches = matchingProducts.filter((item) =>
                products[firstProductCategory].some((p) => p.barcode === item.barcode)
            );
            const otherMatches = matchingProducts.filter((item) =>
                !products[firstProductCategory].some((p) => p.barcode === item.barcode)
            );

            return [...categoryMatches, ...otherMatches].slice(0, 10);
        }

        return matchingProducts.slice(0, 10);
    }, [searchQuery, allProducts, compareList]);


    const similarProducts = useMemo(() => {
        if (compareList.length === 0) return [];

        const firstProduct = compareList[0];
        const firstProductCategory = Object.keys(products).find((key) =>
            products[key].some((p) => p.barcode === firstProduct.barcode)
        );
        if (!firstProductCategory) return [];
        const brandCategoryMatches = products[firstProductCategory].filter(
            (item) =>
                item.brand === firstProduct.brand &&
                !compareList.some((cp) => cp.barcode === item.barcode)
        );

        return brandCategoryMatches;
    }, [compareList, products]);

    const handleCheck = (product) => {
        const isInCompare = compareList.some((p) => p.barcode === product.barcode);
        if (isInCompare) {
            removeFromCompare(product.barcode);
        } else {
            addToCompare(product);
        }
    };

    const limitedSearchResults = filteredProducts.slice(0, 10);

    const getUniqueKey = (item, index) =>
        item.barcode || `${item.name}-${item.brand}-${index}`;

    return (
        <div className="select-other-products-page">
            <header className="pre-header">
                <h1 className="pre-title">✨ Sana İyi Gelecek! ✨</h1>
                <p className="pre-subtitle">
                    Ürünler arasında boğulmana gerek kalmadı, hemen karşılaştırma listeni oluştur ve kendine en uygun ürünü bul!
                </p>
            </header>
            <section className="select-other-products-horizontal-section">
                <div className="select-other-products-horizontal-scroll">
                    {compareList.map((item, index) => {
                        const category = Object.keys(products).find((key) =>
                            products[key].some((p) => p.barcode === item.barcode)
                        ); return (
                            <div
                                key={getUniqueKey(item, index)}
                                className="select-other-products-product-card"
                            >
                                <div className="select-other-products-product-img-wrap">
                                    <img
                                        src={getProductImage(category, item.barcode, item.id)}
                                        alt={item.barcode || item.name}
                                        className="select-other-products-product-img"
                                    />
                                </div>
                                <div className="select-other-products-product-details">
                                    <p className="select-other-products-product-name">{item.name}</p>
                                    <p className="select-other-products-product-brand">{item.brand}</p>
                                    <button
                                        className="select-other-products-action-button select-other-products-remove-button"
                                        onClick={() => removeFromCompare(item.barcode)}
                                    >
                                        Çıkar
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
                {compareList.length >= 2 && (
                    <button
                        className="select-other-products-compare-button-small"
                        onClick={() => navigate("/compare")}
                    >
                        Karşılaştır
                    </button>
                )}
            </section>

            <p className="select-other-products-instruction-text">
                Yukarıdaki ürünlerle karşılaştırmak için yeni ürünler arayın:
            </p>
            <div className="search-container">
                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                <input
                    className="search-bar"
                    type="text"
                    placeholder="Ürün adı veya marka..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            {searchQuery && (
                <section className="select-other-products-horizontal-section">
                    {limitedSearchResults.length === 0 ? (
                        <p className="select-other-products-empty-message">
                            Bu kriterde ürün bulunamadı.
                        </p>
                    ) : (
                        <div className="select-other-products-horizontal-scroll">
                            {limitedSearchResults.map((item, index) => {
                                const category = Object.keys(products).find((key) =>
                                    products[key].some((p) => p.barcode === item.barcode)
                                ); return (
                                    <div
                                        key={getUniqueKey(item, index)}
                                        className="select-other-products-product-card"
                                    >
                                        <div className="select-other-products-product-img-wrap">
                                            <img
                                                src={getProductImage(category, item.barcode, item.id)}
                                                alt={item.barcode || item.name}
                                                className="select-other-products-product-img"
                                            />
                                        </div>
                                        <div className="select-other-products-product-details">
                                            <p className="select-other-products-product-name">
                                                {item.name}
                                            </p>
                                            <p className="select-other-products-product-brand">
                                                {item.brand}
                                            </p>
                                            <button
                                                className="select-other-products-action-button select-other-products-add-button"
                                                onClick={() => handleCheck(item)}
                                            >
                                                Ekle
                                            </button>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </section>
            )}

            {compareList.length > 0 && similarProducts.length > 0 && (
                <section className="select-other-products-horizontal-section">
                    <h2 className="new-feedback-title">
                        Aynı Markadan Öneriler
                    </h2>
                    <div className="select-other-products-horizontal-scroll">
                        {similarProducts.slice(0, 4).map((item, index) => {
                            const category = Object.keys(products).find((key) =>
                                products[key].some((p) => p.barcode === item.barcode)
                            ); return (
                                <div
                                    key={getUniqueKey(item, index)}
                                    className="select-other-products-product-card"
                                >
                                    <div className="select-other-products-product-img-wrap">
                                        <img
                                            src={getProductImage(category, item.barcode, item.id)}
                                            alt={item.barcode || item.name}
                                            className="select-other-products-product-img"
                                        />
                                    </div>
                                    <div className="select-other-products-product-details">
                                        <p className="select-other-products-product-name">
                                            {item.name}
                                        </p>
                                        <p className="select-other-products-product-brand">
                                            {item.brand}
                                        </p>
                                        <button
                                            className="select-other-products-action-button select-other-products-add-button"
                                            onClick={() => addToCompare(item)}
                                        >
                                            Ekle
                                        </button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </section>
            )}
        </div>
    );
};

export default SelectOtherProducts;
